import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'

// evertel
import { Button, Row, Col, InfoBox, Input, Icon, Text, useUI } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { ConsumeInviteController } from '@evertel/invites'
import { InviteActionHandler } from '@evertel/web/invites'


type Opts = {
    opts: {
        departmentMembersCanJoinAsMember: boolean
        roomMembersCanLeave: boolean
    }
}
interface JoinRoomActionButtonProps {
    onClose: () => void
}


const JoinRoomByInviteCode: React.FC<JoinRoomActionButtonProps> = observer(({
    onClose
}) => {

    const { addToast } = useUI()
    const navigate = useNavigate()

    const inviteActionHandler = useService(InviteActionHandler)
    const consumeInviteController = useService(ConsumeInviteController, [])

    const [inviteCode, setInviteCode] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const onChange = (e) => {
        setInviteCode(e.target.value)
    }

    const submitInviteCode = async () => {
        setIsLoading(true)

        try {
            const result = await consumeInviteController.consumeInvite(inviteCode)
            inviteActionHandler.action(result, addToast, navigate)

            onClose()

        } catch (error) {
            addToast({
                color: 'danger',
                message: error.message
            })
        } finally {
            setIsLoading(false)
        }

    }

    return (
        <InfoBox color="info">
            <Row>
                <Col align="left">
                    <Row
                        align="between"
                        className="w-100">
                        <Text
                            tag="h4"
                            bold>
                            Join a Room by Invite Code
                        </Text>
                        <Button
                            onClick={onClose}
                            color="info">
                            <Icon
                                name="times"
                            />
                        </Button>
                    </Row>
                    <Text tag="h5">
                        If you have been given a room invite code please enter it below to join the room
                    </Text>
                    <Input
                        name="inviteCode"
                        value={inviteCode}
                        onChange={onChange}
                        placeholder="Enter the room invite code..."
                    />
                    <Row
                        align="right"
                        className="w-100">
                        <Button
                            loading={isLoading}
                            onClick={submitInviteCode}
                            color="primary"
                            disabled={!inviteCode?.length}
                            className="mt-2">
                            Submit & Join
                        </Button>
                    </Row>
                </Col>
            </Row>
        </InfoBox>
    )
})

export { JoinRoomByInviteCode }
